// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"InsuranceGroupContainer_tableWrap__1OrsZ"};